const normalizeText = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();

const matchesKeyword = (text, keywords = []) => {
  const normalized = normalizeText(text);
  if (!normalized) return false;

  return keywords.some((keyword) => normalized.includes(normalizeText(keyword)));
};

const PROGRAM_SOURCE_OVERRIDES = [
  { match: 'bantuan pendidikan', type: 'zakat', label: 'Zakat' },
  { match: 'beasiswa', type: 'zakat', label: 'Zakat' },
  { match: 'dhuafa', type: 'zakat', label: 'Zakat' },
  { match: 'fakir', type: 'zakat', label: 'Zakat' },
  { match: 'miskin', type: 'zakat', label: 'Zakat' },
  { match: 'yatim', type: 'infak', label: 'Infak' },
  { match: 'ambulance gratis', type: 'infak', label: 'Infak' },
  { match: 'ambulans gratis', type: 'infak', label: 'Infak' },
  { match: 'bantuan bencana', type: 'infak', label: 'Infak' },
  { match: 'wakaf sumur', type: 'wakaf', label: 'Wakaf' },
  { match: 'pembangunan', type: 'wakaf', label: 'Wakaf' },
  { match: 'renovasi', type: 'wakaf', label: 'Wakaf' },
];

const resolveOverride = (text) => {
  const normalized = normalizeText(text);
  if (!normalized) return null;

  return PROGRAM_SOURCE_OVERRIDES.find((item) => normalized.includes(normalizeText(item.match))) || null;
};

export const PENYALURAN_FUNDING_RULES = [
  {
    type: 'zakat',
    label: 'Zakat',
    programKeywords: [
      'bantuan pendidikan',
      'pendidikan',
      'beasiswa',
      'dhuafa',
      'fakir',
      'miskin',
      'beasiswa dhuafa',
      'kesehatan dhuafa',
      'mualaf',
      'gharimin',
      'fisabilillah',
      'ibnu sabil',
      'mustahik',
    ],
    detailKeywords: [
      'zakat',
      'bantuan pendidikan',
      'pendidikan',
      'beasiswa',
      'dhuafa',
      'fakir',
      'miskin',
      'beasiswa dhuafa',
      'kesehatan dhuafa',
      'mustahik',
    ],
  },
  {
    type: 'infak',
    label: 'Infak',
    programKeywords: [
      'yatim',
      'ambulance',
      'ambulans',
      'bencana',
      'sembako',
      'dakwah',
      'sosial',
      'masjid',
      'ramadhan',
      'kemanusiaan',
    ],
    detailKeywords: [
      'infak',
      'infaq',
      'sedekah',
      'yatim',
      'ambulance',
      'ambulans',
      'bencana',
      'sembako',
      'masjid',
      'dakwah',
    ],
  },
  {
    type: 'wakaf',
    label: 'Wakaf',
    programKeywords: [
      'wakaf',
      'sumur',
      'pembangunan',
      'renovasi',
      'aset',
      'tanah',
      'bangunan',
      'pesantren',
      'sekolah',
      'produktif',
    ],
    detailKeywords: [
      'wakaf',
      'sumur',
      'pembangunan',
      'renovasi',
      'aset',
      'tanah',
      'bangunan',
      'produktif',
    ],
  },
];

export const resolveFundingRuleByText = (text, field = 'programKeywords') => {
  const normalized = normalizeText(text);
  if (!normalized) return null;

  return PENYALURAN_FUNDING_RULES.find((rule) => matchesKeyword(normalized, rule[field])) || null;
};

export const resolveProgramFundingMeta = (program, detailMatch = null) => {
  const programName = program?.nama_program || '';
  const divisiName = program?.divisi?.nama_divisi || program?.nama_divisi || '';
  const detailName = detailMatch?.nama_detail_donasi || detailMatch?.nama || '';
  const detailCode = detailMatch?.kode_detail_donasi || detailMatch?.kode || '';
  const overrideMatch = resolveOverride(programName);

  const matchedRule =
    overrideMatch ||
    resolveFundingRuleByText(programName, 'programKeywords') ||
    resolveFundingRuleByText(divisiName, 'programKeywords') ||
    resolveFundingRuleByText(detailName, 'detailKeywords') ||
    resolveFundingRuleByText(detailCode, 'detailKeywords');

  return {
    sourceType: matchedRule?.type || '',
    sourceLabel: matchedRule?.label || 'Belum dipetakan',
    distributionLabel: detailName || programName || 'Program',
    hasFundingRule: Boolean(matchedRule),
  };
};

export const resolveTransactionFundingMeta = (transaction, detailMeta = {}) => {
  const jenisName =
    transaction?.jenis_donasi?.nama_donasi ||
    transaction?.jenisDonasi?.nama_donasi ||
    transaction?.jenis_donasi?.nama ||
    transaction?.jenisDonasi?.nama ||
    transaction?.nama_jenis_donasi ||
    '';

  const detailName = detailMeta?.name || '';
  const detailCode = detailMeta?.code || '';

  const matchedRule =
    resolveFundingRuleByText(jenisName, 'detailKeywords') ||
    resolveFundingRuleByText(detailName, 'detailKeywords') ||
    resolveFundingRuleByText(detailCode, 'detailKeywords');

  return {
    sourceType: matchedRule?.type || '',
    sourceLabel: matchedRule?.label || 'Belum dipetakan',
  };
};
